import React from 'react';
import { TableLoader } from './common/table-loader';
import { PageHeaderLoader } from './common/page-header-loader';
import { TabsLoader } from './common/tabs-loader';

export const CustomerAddressDetailPageLoader = ({ hideActions }: { hideActions?: boolean }) => {
  return (
    <div className="pl-8">
      <PageHeaderLoader hideActions={hideActions} />
      <TabsLoader tabsCount={6} />
      <br />
      <TableLoader />
    </div>
  );
};
